// src/errorStrings.ts
var faidToConnectErrorString = "We are having trouble connecting. Please check your internet connection and try again.";
var unknownErrorString = "There was an issue processing your request. Please try again later or contact support if the problem persists.";
var fallbackErrorString = "Operation failed, please try again later.";
var fileTooLargeErrorString = "The size of the file is too large.";

// src/httpError.ts
var getErrorMessage = (error) => {
  if (error instanceof HttpError) {
    const errors = error.getErrors();
    return Object.values(errors).flat();
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallbackErrorString;
};
var HttpError = class _HttpError extends Error {
  httpStatusCode;
  json;
  constructor(httpStatusCode, json) {
    super();
    Object.setPrototypeOf(this, _HttpError.prototype);
    this.httpStatusCode = httpStatusCode;
    this.json = json;
    this.setErrorMessage();
  }
  setErrorMessage() {
    this.message = `HTTP Status Code: ${this.httpStatusCode}, Details: ${getErrorMessage(this)}`;
  }
  getStatusCode() {
    return this.httpStatusCode;
  }
  setJson(json) {
    this.json = json;
    this.setErrorMessage();
  }
  getJson() {
    if (typeof this.json === "string") {
      return void 0;
    }
    return this.json;
  }
  getErrors() {
    if (this.httpStatusCode === -1 /* FailedToConnect */) {
      return {
        unknown: faidToConnectErrorString
      };
    }
    if (this.json && this.httpStatusCode < 500) {
      if (typeof this.json === "string") {
        return { unknown: this.json };
      }
      if (this.json.errors) {
        return this.json.errors;
      }
      const defaultError = this.json.detail || this.json.type || this.json.errorCode;
      if (defaultError) {
        return { unknown: defaultError };
      }
    }
    return {
      unknown: unknownErrorString
    };
  }
};

// src/notFoundError.ts
var NotFoundError = class _NotFoundError extends HttpError {
  constructor(httpStatusCode = 404, json) {
    super(httpStatusCode, json);
    Object.setPrototypeOf(this, _NotFoundError.prototype);
  }
};

// src/payloadTooLargeError.ts
var PayloadTooLargeError = class _PayloadTooLargeError extends HttpError {
  constructor() {
    super(413, fileTooLargeErrorString);
    Object.setPrototypeOf(this, _PayloadTooLargeError.prototype);
  }
};

// src/unauthorizedError.ts
var UnauthorizedError = class _UnauthorizedError extends HttpError {
  constructor() {
    super(401);
    Object.setPrototypeOf(this, _UnauthorizedError.prototype);
  }
};

// src/createError.ts
async function getContentFromResponse(response) {
  let content;
  try {
    content = await response.clone().json().catch(() => response.clone().text());
  } catch (error) {
    content = response.statusText;
  }
  return content;
}
function createErrorFromResponse(status, json) {
  if (status === 401) return new UnauthorizedError();
  if (status === 404) {
    return new NotFoundError(status, json);
  }
  if (status === 413) {
    return new PayloadTooLargeError();
  }
  return new HttpError(status, json);
}

// src/failToFetchError.ts
var FailToFetchError = class extends HttpError {
  constructor() {
    super(-1 /* FailedToConnect */);
  }
};

export { FailToFetchError, HttpError, NotFoundError, PayloadTooLargeError, UnauthorizedError, createErrorFromResponse, faidToConnectErrorString, fallbackErrorString, fileTooLargeErrorString, getContentFromResponse, getErrorMessage, unknownErrorString };
//# sourceMappingURL=main.js.map
//# sourceMappingURL=main.js.map